<template>
  <div>
    <div class="banner">
      <div class="inner">
        <div class="newbox">
          <div class="listwarp">
            <div class="list" v-for="(item, index) in xwlist" :key="index">
              <div class="lefty"></div>
              <div class="right">
                <div
                  class="listtitle"
                  @click="goxwdetails(item.id, item.typeId)"
                >
                  {{ item.title }}
                </div>
                <div class="listtext">
                  {{ item.info }}
                </div>
              </div>
            </div>
            <div class="sandian">
              <div
                :class="pageIndex == 2 ? 'b' : 'a'"
                @click="previous(2)"
              ></div>
              <div
                :class="pageIndex == 1 ? 'b' : 'a'"
                @click="previous(1)"
              ></div>
              <div
                :class="pageIndex == 3 ? 'b' : 'a'"
                @click="previous(3)"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <el-carousel class="bannerimg" trigger="click">
        <el-carousel-item v-for="item in imglist" :key="item.img">
          <img :src="item.img" alt="" />
          <div class="inner">
            <div class="title">
              {{ item.text }}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="showbox">
      <div class="inner">
        <div class="title">案例展示<span> / CASE SHOW</span></div>
        <div class="tabbox">
          <div
            :class="tabaction == index ? 'tablist tablistaction' : 'tablist'"
            v-for="(item, index) in tablist"
            :key="index"
            @click="changeaction(index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="showimgwarp">
      <div class="imginner xd">
        <img
          class="sj"
          :style="{ left: left1 }"
          src="../assets/img/首页三角形.png"
          alt=""
        />
        <div class="imgwarp">
          <div class="img">
            <img :src="allist[index][0].img" alt="" />
            <div class="ggbox a1">
              <div class="xmm">{{ allist[index][0].title }}</div>
              <div class="text">
                {{ allist[index][0].text }}
              </div>
              <div
                class="ljgd"
                @click="
                  goaldetails(allist[index][0].id, allist[index][0].typeId)
                "
              >
                了解更多
              </div>
            </div>
          </div>
          <div class="img1">
            <img :src="allist[index][1].img" alt="" />
            <div class="ggbox a2">
              <div class="xmm">{{ allist[index][1].title }}</div>
              <div class="text">
                {{ allist[index][1].text }}
              </div>
              <div
                class="ljgd"
                @click="
                  goaldetails(allist[index][1].id, allist[index][0].typeId)
                "
              >
                了解更多
              </div>
            </div>
          </div>
          <div class="img2">
            <img :src="allist[index][2].img" alt="" />
            <div class="ggbox a3">
              <div class="xmm">{{ allist[index][2].title }}</div>
              <div class="text">
                {{ allist[index][2].text }}
              </div>
              <div
                class="ljgd"
                @click="
                  goaldetails(allist[index][2].id, allist[index][0].typeId)
                "
              >
                了解更多
              </div>
            </div>
          </div>
          <div class="img3">
            <img :src="allist[index][3].img" alt="" />
            <div class="ggbox a4">
              <div class="xmm">{{ allist[index][3].title }}</div>
              <div class="text">
                {{ allist[index][3].text }}
              </div>
              <div
                class="ljgd"
                @click="
                  goaldetails(allist[index][3].id, allist[index][0].typeId)
                "
              >
                了解更多
              </div>
            </div>
          </div>
          <div class="img4">
            <img :src="allist[index][4].img" alt="" />
            <div class="ggbox a5">
              <div class="xmm">{{ allist[index][4].title }}</div>
              <div class="text">
                {{ allist[index][4].text }}
              </div>
              <div
                class="ljgd"
                @click="
                  goaldetails(allist[index][4].id, allist[index][0].typeId)
                "
              >
                了解更多
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hxwarp">核心业务 <span> / CORE BUSINESS</span></div>
    <div class="hxywwarp">
      <div class="inner">
        <div class="hxyw">
          <div class="box1">
            <div class="title">技术咨询</div>
            <div class="text">拥有设计、检测资质，提供行业系统技术服务</div>
          </div>
          <div class="box2">
            <div class="title">装备制造</div>
            <div class="text">节能环保、循环利用装备制造</div>
          </div>
          <div class="box3">
            <div class="title">建设运营</div>
            <div class="text">与各地市企业合建循环利用中心，配合各地政府实现零固废排放</div>
          </div>
          <div class="box4">
            <div class="title">信息智能</div>
            <div class="text">
              提供行业信息化智能化服务
            </div>
          </div>
          <div class="box5">
            <img src="../assets/img/case_5.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="hxwarp">资质荣誉 <span> / PRODUCT</span></div>

    <div class="rybox">
      <div class="rywarp">
        <div class="left el-icon-arrow-left" @click="changeleft(0)">
          <!-- <Icon type="ios-arrow-back"></Icon> -->
        </div>
        <div class="rylistwarp">
          <div
            class="rylistwarp1"
            :style="{ left: left + 'px', width: width + 'px' }"
          >
            <div
              class="rylist"
              v-for="(item, index) in ryList"
              :key="index"
              @click="goxwdetails(item.id, item.typeId)"
            >
              <img
                class="ing"
                :src="CommonFunction.fileUrl + item.firstImg"
                alt=""
              />
              <div class="ryname">{{ item.title }}</div>
              <div class="rytext">{{ item.info }}</div>
            </div>
          </div>
        </div>
        <div class="rightt el-icon-arrow-right" @click="changeleft(1)">
          <!-- <Icon type="ios-arrow-forward" /> -->
        </div>
      </div>
    </div>
    <div class="xctg">
      <div class="inner">
        <div class="gksp" @click="govediolist">观看视频</div>
        <div class="wz">
          <div class="left"></div>
          <div class="right">
            <div class="xctg1">宣传推广</div>
            <div class="ylwl">引领交通的未来 享受美好的生活</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xwindex: 1,
      index: 0,
      tablist: [
        "公路工程",
        "市政工程",
        "信息工程",
        "道路养护",
        "机场养护",
        "建筑工程",
        "国家案例",
      ],
      // xwlist: [
      //   [
      //     {
      //       title: "广州凯棱加速向工业5.0转变",
      //       text: "5月16日，为应对沥青路面废旧料微波热再生设备的大规模需求，最大限度减少工人压力，提高生产力，广州市凯棱工业用微波设备有限公司购置焊接机器人、电液伺服数控折弯机、大型悬臂吊、冷风机、轴流风机、洗地机等多种装备，最大限度减少装配和生产中的人工干预需求，打造无尘车间，为精细化生产提供了坚强支撑和有力保障。",
      //     },
      //     {
      //       title: "富士康科技集团莅临考察",
      //       text: "5月11日，富士康科技集团（中国总部）欧阳雄均先生莅临广州凯棱考察交流。当前，广州凯棱中标的富士康科技集团业务，正在紧锣密鼓实施中。",
      //     },
      //     {
      //       title: "拜访包头市固废再生资源利用有限责任公司",
      //       text: "5月11日，集团公司董事长桂学、党委书记余远航奔赴内蒙古包头市，拜访包头市固废再生资源利用有限责任公司，同总经理倪磊针对沥青再生微波拌合站技术做了充分交流，并就后续共同建设微波拌合站达成了初步意向。",
      //     },
      //   ],
      //   [
      //     {
      //       title: "董事长桂学参加高速公路养护高质量创新发展论坛",
      //       text: "10月26日，高速公路养护高质量创新发展论坛暨山东高速集团第二届养护管理科技创新研讨会在威海召开，董事长桂学应邀在大会上做了题为“基于微波加热的沥青再生拌合站关键技术研究”的主旨报告。",
      //     },
      //     {
      //       title: "中霖集团与无锡雪桃集团举行5000型微波搅拌站技术研讨会",
      //       text: "2022年10月29日上午9点，中霖交通科技集团有限公司技术团队与无锡雪桃集团技术团队召开“5000型微波沥青热再生搅拌站技术研讨会”，因疫情原因，会议通过线上视频会议举行，中霖集团董事长桂学、总工程师李群德、无锡雪桃集团总经理张华、广州市凯棱工业用微波设备有限公司董事长桂章和长安大学马登成教授带队参加了会议。",
      //     },
      //     {
      //       title: "【中标喜报】：祝贺公司成功中标！",
      //       text: "热烈庆祝中霖集团成功中标陕西省交通运输厅绿色微波热源对固废新材料沥青路面影响机理及应用技术研究项目，项目编号:MKR2022-004，中标金额300000元。",
      //     },
      //   ],
      //   [
      //     {
      //       title: "中霖集团受邀赴中交西安筑路机械有限公司洽谈合作交流",
      //       text: "2022年9月22日，受中交西安筑路机械有限公司邀请，中霖集团董事长桂学、公司副总经理余远航、销售总监姜忠雪，会同长安大学材料学院党委书记高雁北、高速公路筑养装备与技术教育部工程研究中心副主任马登成一同赴中交西安筑路机械有限公司，就微波再生搅拌站技术研究与商务合作等方面进行座谈交流。中交西安筑路机械有限公司副总经理、总工程师张永卫，总工办主任、绿色智能道路建养装备研究院副院长梁新文，研究院院长吴相军，市场党支部书记、技术应用室主任、计划经营部总经理李国柱等参加了座谈。",
      //     },
      //     {
      //       title: "【中标喜报】：祝贺公司成功中标！",
      //       text: "热烈庆祝中霖集团成功中标湖南省交通规划勘察设计院有限公司-尼勒克县马场大桥工程建设项目、尼勒克县S315线K152+560-科克浩特浩尔蒙古乡-G218线K195+800公路工程建设项目(EPC模式) 施工图设计及后期服务，中标金额12234067元。",
      //     },
      //     {
      //       title: "【专利喜报】热烈祝贺我公司获得三项实用新型专利授权",
      //       text: "日前，公司三项实用新型专利获得国家知识产权局授权，第一项专利名称为“一种试验室用的微波加热设备”，专利号为202122187041.4。第二项专利名称为“一种再生沥青混合料的制备装置”，专利号为202122640025.6。第三项专利名称为“一种微波热风协同加热烘箱”，专利号为202220233237.4。专利图片如下所示：",
      //     },
      //   ],
      // ],
      tabaction: 0,
      left1: "70px",
      imglist: [
        {
          img: require("../assets/img/index-banner.jpg"),
          text: "品质至上 诚信致远 服务一流",
        },
        {
          img: require("../assets/img/index-banner2.jpg"),
          text: "汇聚科技精华 缔造百年中霖",
        },
        {
          img: require("../assets/img/index-banner3.jpg"),
          text: "建精品工程 筑百年中霖",
        },
      ],
      allist: [
        [
          {
            id: "1c88db85-adae-4c11-832a-88467cc9a4a1",
            typeId: "34a07545-ab83-4e1a-a5e9-44ba415672eb",
            img: require("../assets/公路工程/01.jpg"),
            title: "甘肃省庆阳市华池县余家台1号桥建设工程勘察设计",
            text: "项目位于甘肃省庆阳市华池县，桥长148米，桥面宽17米，新修桥头引道228米，引道路基宽16米。",
          },
          {
            id: "d60f9e50-cc1c-48e2-bae1-1097317eee3b",
            typeId: "34a07545-ab83-4e1a-a5e9-44ba415672eb",
            img: require("../assets/公路工程/02.jpg"),
            title: "汉中市汉江2号桥",
            text: "主桥、引桥工程全长645m。主桥为预应力混凝土变截面连续梁，孔跨全长427m，共7跨，各孔跨径为36m+65m+3X75m+65m36m。本项目由中霖设计与中国水电顾问集团西北勘测设计院合作共同完成。",
          },
          {
            id: "6c9eae8f-d557-4826-8d60-f233dc8daa83",
            typeId: "34a07545-ab83-4e1a-a5e9-44ba415672eb",
            img: require("../assets/公路工程/03.jpg"),
            title: "布尔津西大桥",
            text: "并将主塔采用弧线处理，与拉索一起构成了行驶中的帆船，寓意着扬帆起航。",
          },
          {
            id: "7cd81af5-9450-4e55-9189-322cba870600",
            typeId: "34a07545-ab83-4e1a-a5e9-44ba415672eb",
            img: require("../assets/公路工程/04.jpg"),
            title: "达坂城景观桥",
            text: "跨径45+19m,主塔高20米，桥梁总长64.8m，桥宽8.2m。我公司2017年5月完成设计，2017年11月建成通行。",
          },
          {
            id: "7cd81af5-9450-4e55-9189-322cba870600",
            typeId: "34a07545-ab83-4e1a-a5e9-44ba415672eb",
            img: require("../assets/公路工程/05.jpg"),
            title: "新疆35团至若羌高速公路工程",
            text: " 项目位于新疆维吾尔自治区巴音郭楞蒙古自治州若羌县和尉犁县境内。全长95km，是新疆重要的南北大通道。本项目由中霖设计于2017年与中交第一公路勘察设计研究院合作共同完成。",
          },
        ],
        [
          {
            id: "787c48af-445d-459f-bc41-42c5afc460e2",
            typeId: "319d4b31-d4e1-42e2-b5d6-331fdbfaca19",
            img: require("../assets/市政工程/01.jpg"),
            title: "青岛蓝色硅谷核心区跨越滨海大道天桥项目设计",
            text: "位于青岛蓝色硅谷核心区的沙滩二路以南，沙滩三路以北，横跨滨海大道，与滨海大道西侧蓝和东侧的蓝色中心商业楼连接东西两区规划融为一体",
          },
          {
            id: "a44b1612-af14-4eb7-a348-b64743889d37",
            typeId: "319d4b31-d4e1-42e2-b5d6-331fdbfaca19",
            img: require("../assets/市政工程/02.jpg"),
            title: "郑州市南四环和京广路互通立交设计",
            text: "郑州京广快速路南延，起点为绕城高速，终点接南水北调大桥，全长约5公里。南四环和京广路互通立交是重要的交通节点，我公司承担该节点的主体设计。目前该项目已经建成通车。",
          },
          {
            id: "4855763a-215e-4984-8774-8336ccdce4a2",
            typeId: "319d4b31-d4e1-42e2-b5d6-331fdbfaca19",

            img: require("../assets/市政工程/03.jpg"),
            title: "三和三街斜腿钢构桥",
            text: "位于临沂市柳青河上，是南坊新区建设的重要组成部分。斜腿钢构桥具有结构轻巧，外形飘逸而富有现代感的优点，给人以美的视觉感受。",
          },
          {
            id: "8b4bba42-916f-48e0-af47-3cd5c3c7ea41",
            typeId: "319d4b31-d4e1-42e2-b5d6-331fdbfaca19",
            img: require("../assets/市政工程/04.jpg"),
            ttile: "山东迎宾大桥",
            text: "迎宾大桥-独塔双锁面自锚式混凝土悬索桥，桥梁主跨70m，边跨25m，主缆中心距32m，吊索沿顺桥向间距4m，桥梁横断面宽43m，是我国第一座单塔砼自锚式悬索桥。",
          },
          {
            id: "",
            typeId: "",
            img: require("../assets/市政工程/05.jpg"),
            title: "暂无更多",
            text: "",
          },
        ],
        [
          {
            id: "ec02ddbb-4810-4f27-8926-3cc614851312",
            typeId: "c2f4a07a-05a8-4198-a9af-16228167f0ff",
            img: require("../assets/信息工程/01.jpg"),
            title: "中建三局安装工程有限公司设计管理平台",
            text: "中建三局设计管理系统应用于中建三局安装工程有限公司，只要包括各个分公司及总公司的项目管理，任务管理，图纸在线校审定，人员绩效管理，项目档案管理，人员信息维护。",
          },
          {
            id: "eb43c550-545d-4bf7-b8bc-a16e83d9abad",
            typeId: "c2f4a07a-05a8-4198-a9af-16228167f0ff",
            img: require("../assets/信息工程/02.jpg"),
            title: "西安城市规划设计研究院项目管理系统",
            text: "西安城市规划设计研究院项目管理系统，应用于规划院内部各个部门，主要模块有项目管理，投标信息管理，统计报表，文件管理，配置管理，人员信息管理。",
          },
          {
            id: "02132f4f-48df-448d-ae78-ea4cba2d7dbd",
            typeId: "c2f4a07a-05a8-4198-a9af-16228167f0ff",
            img: require("../assets/信息工程/03.jpg"),
            title: "陕西建工安装集团设计研究院项目信息管理系统",
            text: "陕建项目成本测算系统使用用户为陕建设计院人员，在给客户报价时根据项目信息在系统中进行报价核算，设计院管理人员可在系统上查看院里所有项目报价情况，主要功能有，项目成本测算，项目材料等基础维护，人员信息维护。",
          },
          {
            id: "cc373ba9-05f9-470c-a3f2-9e429a16516d",
            typeId: "c2f4a07a-05a8-4198-a9af-16228167f0ff",
            img: require("../assets/信息工程/04.jpg"),
            title: "铁一院证照管理系统",
            text: "证照管理系统应用于西安铁一院工程监理有限公司内部的证件的管理工作，主要包括证件的电子化录入，证件的借出及还入，证件的借还记录，企业人员信息的维护。",
          },
          {
            img: require("../assets/信息工程/suidao_0.jpg"),
            title: "中霖隧道智慧通风管理系统",
            text: "设计企业管理平台，工程行业内容营销平台",
            id: "bce65993-1eb3-46be-9d7f-c81d0410edd2",
            typeId: "c2f4a07a-05a8-4198-a9af-16228167f0ff",
          },
        ],
        [
          {
            id: "",
            typeId: "",
            img: require("../assets/道路养护/01.jpg"),
            title: "暂无更多",
            text: "",
          },
          {
            id: "",
            typeId: "",
            img: require("../assets/道路养护/02.jpg"),
            text: "",
            title: "暂无更多",
          },
          {
            id: "",
            typeId: "",
            img: require("../assets/道路养护/03.jpg"),
            text: "",
            title: "暂无更多",
          },
          {
            id: "",
            typeId: "",
            img: require("../assets/道路养护/04.jpg"),
            text: "",
            title: "暂无更多",
          },
          {
            id: "",
            typeId: "",
            img: require("../assets/道路养护/05.jpg"),
            text: "",
            title: "暂无更多",
          },
        ],
        [
          {
            id: "069679df-8b37-48e7-8251-9ece38f6fc77",
            typeId: "15305640-cc8c-405b-8acf-faf9dfe6e1a5",
            img: require("../assets/机场养护/01.jpg"),
            text: "",
            title: "西安咸阳机场道面MMA薄层快速修复工程",
          },
          {
            id: "e0bb6b32-871f-49ac-b9ea-1bab1f291585",
            typeId: "15305640-cc8c-405b-8acf-faf9dfe6e1a5",
            img: require("../assets/机场养护/02.jpg"),
            text: "",
            title: "首都国际机场道面薄层快速修复工程",
          },
          {
            id: "8aa85365-da10-4500-b0eb-3c693ad2bb99",
            typeId: "15305640-cc8c-405b-8acf-faf9dfe6e1a5",
            img: require("../assets/机场养护/03.jpg"),
            text: "",
            title: "四川双流机场道面薄层快速修复工程",
          },
          {
            id: "6a90e3e8-e863-4989-8ca7-3cdff3d909f4",
            typeId: "15305640-cc8c-405b-8acf-faf9dfe6e1a5",
            img: require("../assets/机场养护/04.jpg"),
            text: "",
            title: "固原机场应急抢修",
          },
          {
            id: "",
            typeId: "",
            img: require("../assets/机场养护/05.jpg"),
            text: "",
            title: "暂无更多",
          },
        ],
        [
          {
            id: "e73056df-c80a-4de4-93e0-0757adcff548",
            typeId: "5f683dda-9508-4d68-965e-fbf3a8867180",
            img: require("../assets/建筑工程/01.jpg"),
            text: "",
            title: "固原九龙国际广场",
          },
          {
            id: "e1b75d83-28c8-40a8-95e0-9398981385c3",
            typeId: "5f683dda-9508-4d68-965e-fbf3a8867180",
            img: require("../assets/建筑工程/02.jpg"),
            text: "",
            title: "浊漳河温泉旅游度假村",
          },
          {
            id: "8682d2ad-565c-4ba1-a7a8-255e6478bc47",
            typeId: "5f683dda-9508-4d68-965e-fbf3a8867180",
            img: require("../assets/建筑工程/03.jpg"),
            text: "",
            title: "蜀河古镇",
          },
          {
            id: "3fe8fcb5-c03f-4e24-9321-2e13c7bb846d",
            typeId: "5f683dda-9508-4d68-965e-fbf3a8867180",
            img: require("../assets/建筑工程/04.jpg"),
            text: "",
            title: "汉阴县老年公寓",
          },
          {
            id: "",
            typeId: "",
            img: require("../assets/建筑工程/05.jpg"),
            text: "",
            title: "暂无更多",
          },
        ],
        [
          {
            id: "26348b36-7305-43fd-b974-e109dca9241f",
            typeId: "7d1c4502-5311-4c89-8587-2c497923d6d7",
            img: require("../assets/国际案例/01.jpg"),
            title: "老挝占巴塞省道路桥梁工程",
            text: "",
          },
          {
            id: "9f142b65-e513-4123-8b4e-58c5e492e228",
            typeId: "7d1c4502-5311-4c89-8587-2c497923d6d7",
            img: require("../assets/国际案例/02.jpg"),
            text: "",
            title: "萨郎隧道管理中心和收费站",
          },
          {
            id: "41f7f1d0-01a7-4069-8c9d-de37079d88c6",
            typeId: "7d1c4502-5311-4c89-8587-2c497923d6d7",
            img: require("../assets/国际案例/03.jpg"),
            text: "",
            title: "萨郎隧道出口鸟瞰",
          },
          {
            id: "947b9c7a-538c-47ea-8cda-9db1f50ec6f8",
            typeId: "7d1c4502-5311-4c89-8587-2c497923d6d7",
            img: require("../assets/国际案例/04.jpg"),
            text: "",
            title: "乌兹别克斯坦立交",
          },
          {
            id: "",
            typeId: "",
            img: require("../assets/国际案例/05.jpg"),
            text: "",
            title: "暂无更多",
          },
        ],
      ],
      left: 0,
      loading: false,
      pageIndex: 1,
      pageSize: 3,
      xwlist: [],
      sortType: "desc", //排序类型normal(默认)asc(升序)desc(降序)
      sortKey: "PublishTime", //排序列的key
      alpageIndex: 1,
      alpageSize: 7,
      AlNamelist: [],
      ryList: [],
      width: "",
    };
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
    this.getxwlist();
    this.getanlist();
    this.getryList();
  },
  methods: {
    cahgnewidth() {
      let width = document.documentElement.clientWidth;
      if (width >= 601) {
        this.widht = this.ryList.length * 194;
      } else {
        this.widht = "";
      }
    },
    getanlist() {
      this.loading = true;
      let searchObj = {
        code: "CaseType",
        pageIndex: this.alpageIndex, // 起始页
        pageSize: this.alpageSize, // 查询数量
        sort: "",
      };
      this.$http
        .get("api/Case_InfoNod/GetListByParentCode", { params: searchObj })
        .then((res) => {
          if (res.status) {
            this.tablist = res.result;
          } else {
            this.$message({ type: "warning", message: res.message });
          }
          this.loading = false;
        });
    },
    goxwdetails(id, typeId) {
      this.$router.push({
        path: "/home/NewsDetails",
        query: { id: id, typeId: typeId },
      });
    },
    getxwlist() {
      this.loading = true;
      let searchObj = {
        // typeId: "5454a110-7d40-4ade-a2fa-c1d963b7eb95", //默认公司要闻
        typeName: "公司要闻",
        pageIndex: this.pageIndex, // 起始页
        pageSize: this.pageSize, // 查询数量
        sort: this.sortKey + " " + this.sortType,
      };
      this.$http
        .get("api/News_InfoNod/GetList", { params: searchObj })
        .then((res) => {
          if (res.status) {
            let list = res.result;
            list.forEach((v) => {
              v.info = this.CommonFunction.StripHTML(v.info);
            });
            this.xwlist = list;
          } else {
            this.$message({ type: "warning", message: res.message });
          }
          this.loading = false;
        });
    },
    //资质荣誉列表
    getryList() {
      let searchObj = {
        // typeId: "e87ab2bf-13fa-4813-85d1-bbe3da6c1418", //默认资质荣誉
        typeName: "资质荣誉",
        pageIndex: 0, // 起始页
        pageSize: 0, // 查询数量
        sort: "PublishTime desc",
      };
      this.$http
        .get("api/News_InfoNod/GetList", { params: searchObj })
        .then((res) => {
          if (res.status) {
            this.ryList = res.result;
            this.ryList.forEach((v) => {
              v.info = this.CommonFunction.StripHTML(v.info);
            });
            this.cahgnewidth();
          } else {
            this.$message({ type: "warning", message: res.message });
          }
        });
    },
    changeleft(index) {
      let length = this.ryList.length - 5;
      if (index == 1) {
        if (this.left <= -(194 * length)) {
          this.left = -(194 * length);
        } else {
          this.left -= 194;
        }
      } else {
        if (this.left >= 0) {
          this.left = 0;
        } else {
          this.left += 194;
        }
      }
    },
    goaldetails(id, typeId) {
      if (id == "" || typeId == "") {
        return;
      } else {
        this.$router.push({
          path: "/home/ExampleDisplay/Details",
          query: { id: id, typeId: typeId },
        });
      }
    },

    previous(index) {
      this.pageIndex = index;
      this.xwlist = [];
      this.getxwlist();
    },
    changeaction(index) {
      this.index = index;
      this.tabaction = index;
      if (index == 0) {
        this.left1 = "70px";
      } else if (index == 1) {
        this.left1 = "240px";
      } else if (index == 2) {
        this.left1 = "410px";
      } else if (index == 3) {
        this.left1 = "590px";
      } else if (index == 4) {
        this.left1 = "760px";
      } else if (index == 5) {
        this.left1 = "930px";
      } else if (index == 6) {
        this.left1 = "1100px";
      }
    },
    govediolist() {
      this.$router.push("/home/Video");
    },
  },
};
</script>

<style lang="scss" scoped>
.banner .el-carousel__indicators--horizontal {
  display: none;
}

@media screen and (min-width: 601px) {
  .banner {
    width: 100%;
    height: 699px !important;

    ::v-deep .el-carousel__container {
      width: 100%;
      height: 699px !important;
    }
  }

  .banner {
    width: 100%;
    background-size: cover;
    height: 699px;
    position: relative;

    .bannerimg {
      width: 100%;
      height: 100% !important;
      img {
        width: 100%;
        height: 100% !important;
        display: block;
      }
    }
    .inner {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      z-index: 999;
      .title {
        font-size: 48px;
        line-height: 48px;
        color: #fff;
        margin-top: 125px;
        margin-bottom: 45px;
      }
      .newbox {
        margin-top: 212px;
        width: 780px;
        height: 390px;
        background: rgba(40, 97, 174, 0.7);
        .listwarp {
          width: 100%;
          height: 100%;
          overflow: hidden;
          .list {
            width: 100%;
            height: 100px;
            padding: 0 35px;
            overflow: hidden;
            .lefty {
              width: 12px;
              height: 12px;
              background: #d4e3f8;
              border-radius: 6px;
              float: left;
              margin-top: 65px;
            }
            .right {
              float: left;
              width: 670px;
              margin-left: 15px;
              margin-top: 40px;
              .listtitle {
                cursor: pointer;
                font-size: 24px;
                color: #dff1ff;
                line-height: 24px;
                margin-bottom: 15px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .listtext {
                width: 100%;
                font-size: 18px;
                line-height: 18px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #9eb3e8;
              }
            }
          }
          .sandian {
            width: 100%;
            overflow: hidden;
            margin-top: 45px;
            padding-right: 45px;
            box-sizing: border-box;
            .a {
              width: 8px;
              height: 8px;
              border-radius: 4px;
              background: #cadcf4;
              margin-top: 2px;
              float: right;
              margin-left: 4px;
              cursor: pointer;
            }
            .b {
              cursor: pointer;
              margin-left: 4px;
              float: right;
              width: 12px;
              height: 12px;
              border-radius: 6px;
              background: #cadcf4;
            }
          }
        }
      }
    }
  }
  .showbox {
    width: 100%;
    overflow: hidden;
    .title {
      width: 100%;
      text-align: center;
      color: #263c92;
      font-size: 48px !important;
      line-height: 48px !important;
      margin-top: 100px !important;

      margin-bottom: 35px !important;
      span {
        color: #000;
      }
    }
    .tabbox {
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: space-around;
      margin-bottom: 20px !important;
      flex-wrap: wrap;
      .tablist {
        padding: 0 20px !important;
        border-radius: 5px;
        font-size: 24px !important;
        color: #676767;
        line-height: 48px !important;
        cursor: pointer;
      }
      .tablist:hover {
        color: #fff;
        background: #263c92;
      }
      .tablistaction {
        color: #fff;
        background: #263c92;
      }
    }
  }
  .showimgwarp {
    width: 100%;
    .xd {
      position: relative;
      .sj {
        display: block !important;
        position: absolute;
        width: 40px;
        top: -22px;
        z-index: 99999;
      }
    }
    .imginner {
      width: 1220px !important;
      margin: 20px auto 0px !important;
      .imgwarp {
        position: relative;
        width: 1200px !important;
        margin: 0px auto;
        overflow: hidden;
        box-shadow: 0 0 10px 2px #d2d0d1;
        padding: 25px 22px 30px !important;
        box-sizing: border-box;

        .img,
        .img1,
        .img2,
        .img3,
        .img4 {
          cursor: pointer;
          position: relative;
          float: left;
          display: block;
          height: 316px !important;
          margin-right: 12px !important;
          width: 377px !important;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .img {
          width: 766px !important;
          margin-bottom: 12px !important;
        }
        .img1 {
          margin-right: 0px !important;
          margin-bottom: 12px !important;
        }
        .img4 {
          margin-right: 0px !important;
        }
      }
    }
  }
  .a1,
  .a2,
  .a3,
  .a4,
  .a5 {
    display: none !important;
  }
  .ggbox {
    position: absolute;
    bottom: 34px !important;
    left: 42px !important;
    width: 285px !important;
    height: 195px !important;
    background: rgba(40, 97, 174, 0.7);
    padding: 0 20px !important;
    box-sizing: border-box;
    .xmm {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100% !important;
      font-size: 20px !important;
      line-height: 30px !important;
      margin-top: 20px !important;
      margin-bottom: 10px !important;
      color: #e8eaff !important;
    }
    .text {
      width: 100% !important;
      font-size: 14px !important;
      line-height: 24px !important;
      color: #e8eaff !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      display: -webkit-box !important;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      margin-bottom: 15px !important;
    }
    .ljgd {
      position: absolute;
      right: 173px !important;
      top: 150px !important;
      padding: 0 20px !important;
      line-height: 26px !important;
      height: 26px;
      border: 1px solid #fcffff !important;
      font-size: 12px !important;
      text-align: center !important;
      display: inline-block !important;
      color: #f4ffff !important;
      cursor: pointer;
    }
  }
  .img:hover .a1 {
    display: block !important;
  }
  .img1:hover .a2 {
    display: block !important;
  }
  .img2:hover .a3 {
    display: block !important;
  }
  .img3:hover .a4 {
    display: block !important;
  }
  .img4:hover .a5 {
    display: block !important;
  }
  .hxwarp {
    width: 100% !important;
    text-align: center;
    font-size: 46px !important;
    color: #283c92 !important;
    line-height: 46px !important;
    margin-top: 80px !important;
    margin-bottom: 46px !important;
    span {
      color: #000;
    }
  }
  .hxywwarp {
    width: 100%;
    height: 422px;
    margin-bottom: 100px;
    .hxyw {
      width: 100% !important;
      height: 422px !important;
      overflow: hidden;
      position: relative;
    }
    .box1 {
      position: absolute;
      top: 0 !important;
      left: 0 !important;
      width: 463px !important;
      height: 181px !important;
      background: url(../assets/img/case_1.png) no-repeat;
      .title {
        font-size: 24px !important;
        color: #333 !important;
        margin-left: 126px !important;
        margin-top: 40px !important;
        line-height: 24px !important;
        margin-bottom: 15px !important;
        width: 256px !important;
      }
      .text {
        width: 256px !important;
        margin-left: 126px !important;
        color: #333 !important;
        font-size: 16px !important;
        line-height: 30px !important;
      }
    }
    .box2 {
      top: 0 !important;
      right: 0 !important;
      position: absolute !important;
      width: 463px !important;
      height: 181px !important;
      background: url(../assets/img/case_2.png) no-repeat;
      overflow: hidden;
      .title {
        float: right !important;
        font-size: 24px !important;
        color: #333 !important;
        margin-right: 126px !important;
        margin-top: 40px !important;
        line-height: 24px !important;
        margin-bottom: 15px !important;
        width: 256px !important;
        text-align: right !important;
      }
      .text {
        float: right;
        width: 256px;
        margin-right: 126px;
        color: #333;
        font-size: 16px;
        line-height: 30px;
        text-align: right;
      }
    }
    .box3 {
      left: 0;
      bottom: 0;
      position: absolute;
      width: 463px;
      height: 181px;
      background: url(../assets/img/case_3.png) no-repeat;
      .title {
        font-size: 24px;
        color: #333;
        margin-left: 126px;
        margin-top: 40px;
        line-height: 24px;
        margin-bottom: 15px;
        width: 256px;
      }
      .text {
        width: 256px;
        margin-left: 126px;
        color: #333;
        font-size: 16px;
        line-height: 30px;
      }
    }
    .box4 {
      right: 0 !important;
      bottom: 0 !important;
      position: absolute;
      width: 463px !important;
      height: 181px !important;
      background: url(../assets/img/case_4.png) no-repeat;
      .title {
        float: right !important;
        font-size: 24px !important;
        color: #333 !important;
        margin-right: 126px !important;
        margin-top: 40px !important;
        line-height: 24px !important;
        margin-bottom: 15px !important;
        width: 256px !important;
        text-align: right !important;
      }
      .text {
        float: right !important;
        width: 256px !important;
        margin-right: 126px !important;
        color: #333 !important;
        font-size: 16px !important;
        line-height: 30px !important;
        text-align: right !important;
      }
    }
    .box5 {
      display: block !important;
      width: 550px !important;
      height: 422px !important;
      position: absolute;
      top: 6px !important;
      left: 360px !important;
      img {
        display: block;
      }
    }
  }
  .xctg {
    width: 100% !important;
    height: 565px !important;
    background: url(../assets/img/zl_spbg.jpg) no-repeat;
    background-size: cover;
    .inner {
      position: relative;
      .gksp {
        position: absolute;
        cursor: pointer;
        padding: 0 100px !important;
        height: 50px !important;
        background: #263c92;
        color: #fff;
        line-height: 50px !important;
        text-align: center;
        top: 370px !important;
        right: 40px !important;
        font-size: 18px !important;
        font-weight: 550 !important;
      }
      .wz {
        position: absolute;
        left: 0 !important;
        top: 100px !important;
        overflow: hidden;
        .left {
          width: 1px !important;
          height: 108px !important;
          float: left;
          background: #f8ffff;
          margin-top: 5px !important;
        }
        .right {
          float: left !important;
          margin-left: 35px !important;
          .xctg1 {
            font-size: 40px !important;
            color: #fbfcff;
            line-height: 40px !important;
          }
          .ylwl {
            color: #fff9fd;
            line-height: 38px !important;
            font-size: 38px !important;
            margin-top: 35px !important;
          }
        }
      }
    }
  }

  .rybox {
    width: 100% !important;
    .rywarp {
      height: 400px !important;
      width: 1220px !important;
      margin: 0 auto 100px !important;
      box-shadow: 0 0 10px 2px #d2d0d1;
      padding: 60px 0px !important;
      box-sizing: border-box;
      .left {
        display: block !important;
        cursor: pointer;
        float: left !important;
        width: 115px !important;
        height: 275px !important;
        text-align: center;
        color: #cdcdcd;
        font-size: 70px !important;
        line-height: 275px !important;
        // display: flex;
        // justify-content: center;
        // align-items: center;
      }
      .rightt {
        display: block !important;
        cursor: pointer;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        float: right;
        width: 99px !important;
        line-height: 275px !important;
        height: 275px !important;
        text-align: center;
        color: #cdcdcd;
        font-size: 70px !important;
      }

      .rylistwarp {
        height: 280px !important;
        width: 970px !important;
        float: left !important;
        overflow: hidden;
        position: relative;
      }
      .rylistwarp1 {
        position: absolute;
        // width: 970px !important;
        overflow-x: auto;
        overflow-y: hidden;
        height: 280px !important;
      }
      .rylist {
        cursor: pointer;
        position: relative;
        // margin-left: -2px;
        border-radius: 5px !important;
        float: left;
        height: 275px !important;
        width: 194px !important;
        box-sizing: border-box;
        border: 1px solid #eeeeee;
        // transition: width 0.5s,height 0.1s;
        // transition: height 0.5s;
        img {
          // transition: width 0.1s;
          width: 170px !important;
          height: 130px !important;
          display: block;
          margin: 15px auto 0px !important;
        }
        .ryname {
          font-size: 18px !important;
          color: #555555;
          font-weight: 550 !important;
          text-align: center;
          line-height: 20px !important;
          margin-top: 20px !important;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .rytext {
          margin: 15px auto !important;
          text-align: center !important;
          width: 150px !important;
          font-size: 14px !important;
          color: #5f5f5f !important;
          line-height: 25px !important;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
      .rylist:hover {
        position: relative;
        width: 210px;
        height: 300px;
        z-index: 99999;
        border-radius: 5px;
        top: -10px;
        border: none;
        box-shadow: 0 0 10px 2px #d2d0d1;
      }
      .rylist:hover .ing {
        width: 190px;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .banner .el-carousel__container {
    width: 100%;
    height: 100% !important;
  }
  .banner {
    width: 100%;
    background-size: cover;
    position: relative;
    height: 140px;
    .bannerimg {
      width: 100%;
      height: 140px;
      img {
        width: 100%;
        height: 100% !important;
        display: block;
      }
    }
    .inner {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      z-index: 999;
      .title {
        font-size: 24px;
        line-height: 24px;
        color: #fff;
        margin: 65px auto 0px;
        text-align: center;
      }
      .newbox {
        display: none;
        margin-top: 212px;
        width: 780px;
        height: 390px;
        background: rgba(40, 97, 174, 0.7);
        .listwarp {
          width: 100%;
          height: 100%;
          overflow: hidden;
          .list {
            width: 100%;
            height: 100px;
            padding: 0 35px;
            overflow: hidden;
            .lefty {
              width: 12px;
              height: 12px;
              background: #d4e3f8;
              border-radius: 6px;
              float: left;
              margin-top: 65px;
            }
            .right {
              float: left;
              width: 670px;
              margin-left: 15px;
              margin-top: 40px;
              .listtitle {
                font-size: 24px;
                color: #dff1ff;
                line-height: 24px;
                margin-bottom: 15px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .listtext {
                width: 100%;
                font-size: 18px;
                line-height: 18px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #9eb3e8;
              }
            }
          }
          .sandian {
            width: 100%;
            overflow: hidden;
            margin-top: 45px;
            padding-right: 45px;
            box-sizing: border-box;
            .a {
              width: 8px;
              height: 8px;
              border-radius: 4px;
              background: #cadcf4;
              margin-top: 2px;
              float: right;
              margin-left: 4px;
            }
            .b {
              margin-left: 4px;
              float: right;
              width: 12px;
              height: 12px;
              border-radius: 6px;
              background: #cadcf4;
            }
          }
        }
      }
    }
  }

  .showbox {
    width: 100%;
    overflow: hidden;
    .title {
      font-weight: 550;
      width: 100%;
      text-align: center;
      color: #263c92;
      font-size: 20px;
      line-height: 20px;
      margin-top: 20px;
      margin-bottom: 15px;
      span {
        color: #000;
      }
    }
    .tabbox {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      justify-content: space-around;
      margin-bottom: 10px;
      flex-wrap: wrap;
      .tablist {
        padding: 0 8px;
        border-radius: 5px;
        font-size: 16px;
        color: #676767;
        line-height: 30px;
        cursor: pointer;
      }
      .tablist:hover {
        color: #fff;
        background: #263c92;
      }
      .tablistaction {
        color: #fff;
        background: #263c92;
      }
    }
  }
  .showimgwarp {
    width: 100%;
    .xd {
      position: relative;
      .sj {
        display: none;
        position: absolute;
        width: 40px;
        top: -22px;
        z-index: 99999;
      }
    }
    .imginner {
      width: 100%;
      padding: 0 10px;
      margin: 0px auto 0px;
      box-sizing: border-box;
      .imgwarp {
        position: relative;
        width: 100%;
        margin: 0px auto;
        overflow: hidden;
        box-sizing: border-box;
        .img {
          margin: 0;
        }
        .img1,
        .img3 {
          margin-right: 10px;
        }
        .img,
        .img1,
        .img2,
        .img3,
        .img4 {
          position: relative;
          float: left;
          display: block;
          width: calc(50% - 5px);
          border: 1px solid #ededed;
          margin-bottom: 10px;
          padding-bottom: 5px;
          img {
            width: 100%;
            display: block;
          }
        }
        .img {
          width: 100%;
          margin-bottom: 10px;
        }
      }
    }
  }
  .a1,
  .a2,
  .a3,
  .a4,
  .a5 {
    display: block !important;
    width: 100%;
    padding: 0 5px;
    box-sizing: border-box;
    .xmm {
      font-size: 16px;
      padding-top: 5px;
      padding-bottom: 5px;
      margin-top: 0;
      line-height: 20px;
      word-break: break-all;
      word-wrap: break-word;
      color: #333;
    }
    .text {
      word-break: break-all;
      word-wrap: break-word;
      font-size: 14px;
      line-height: 18px;
      color: #666;
    }
    .ljgd {
      position: absolute;
      top: 100px;
      right: 10px;
      color: #fff;
      padding: 0 7px;
      line-height: 25px;
      background: rgba($color: #2861ae, $alpha: 0.7);
      // border: 1px solid #fff;
      font-size: 12px;
    }
  }
  .hxwarp {
    width: 100%;
    text-align: center;
    font-weight: 550;
    font-size: 20px;
    color: #283c92;
    line-height: 20px;
    margin-top: 15px;
    margin-bottom: 15px;
    span {
      color: #000;
    }
  }
  .hxywwarp {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    .hxyw {
      width: 100%;
      margin-bottom: 10px;
      .box1,
      .box2,
      .box3,
      .box4 {
        width: 100%;
        .title {
          font-size: 18px;
          color: #263c92;
          line-height: 35px;
        }
        .text {
          font-size: 14px;
          color: #333;
          line-height: 20px;
        }
      }
      .box5 {
        display: none;
      }
    }
  }
  .rybox {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    overflow: hidden;
    .rywarp {
      width: 100%;
      .left,
      .rightt {
        display: none;
      }
    }
    .rylistwarp {
      width: 100%;
      .rylist {
        width: 100%;
        border: 1px solid #ededed;
        margin-bottom: 10px;
        border-radius: 5px;
        padding-bottom: 5px;
        img {
          width: 100%;
          display: block;
        }
        .ryname {
          margin-top: 5px;
          text-align: center;
          color: #555555;
          font-weight: 550;
          line-height: 25px;
          font-size: 18px;
        }
        .rytext {
          text-align: center;
          font-size: 14px;
          color: #5f5f5f;
          line-height: 25px;
        }
      }
    }
  }
  .xctg {
    width: 100%;
    background: url(../assets/img/zl_spbg.jpg) no-repeat;
    background-size: cover;
    height: 110px;
    .inner {
      position: relative;
      .gksp {
        position: absolute;
        cursor: pointer;
        height: 30px;
        background: #263c92;
        color: #fff;
        line-height: 30px;
        text-align: center;
        top: 70px;
        right: 10px;
        font-size: 14px;
        // font-weight: 550;
        padding: 0 8px;
      }
      .wz {
        position: absolute;
        left: 15px;
        top: 20px;
        overflow: hidden;
        .left {
          width: 1px;
          height: 45px;
          float: left;
          background: #f8ffff;
          margin-top: 2px;
        }
        .right {
          float: left;
          margin-left: 10px;
          .xctg1 {
            font-size: 20px;
            color: #fbfcff;
            line-height: 20px;
          }
          .ylwl {
            color: #fff9fd;
            line-height: 14px;
            font-size: 14px;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>